import { render } from "./AddQuestionDialog.vue?vue&type=template&id=5ac5ab95&scoped=true&ts=true"
import script from "./AddQuestionDialog.vue?vue&type=script&lang=ts"
export * from "./AddQuestionDialog.vue?vue&type=script&lang=ts"

import "./AddQuestionDialog.vue?vue&type=style&index=0&id=5ac5ab95&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac5ab95"]])

export default __exports__